import { ProductOrBrand } from "./alternativeTypes";

export const appliancesProducts: ProductOrBrand[] = [
  {
    name: "Whirlpool",
    ownerCountry: "US",
    categories: ["appliances", "major-appliances"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Whirlpool_Corporation",
      "http://whirlpool.com/",
    ],
  },
  {
    name: "Braun",
    ownerCountry: "US",
    headquarterIn: "DE",
    categories: ["appliances", "small-appliances"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Braun_(company)"
    ],
  },
  {
    name: "KitchenAid",
    ownerCountry: "US",
    categories: ["appliances", "small-appliances"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/KitchenAid",
      "http://www.kitchenaid.com/",
    ],
  },
  {
    name: "SEB",
    ownerCountry: "FR",
    categories: ["appliances", "small-appliances"],
    availableIn: [
      "FR", "MX", "PL", "CZ", "SI", "PT", "TR"
    ],
    sourceLinks: [
      "https://fr.wikipedia.org/wiki/Groupe_SEB",
    ],
  },
  {
    name: "Breville",
    ownerCountry: "AU",
    categories: ["appliances", "small-appliances"],
    availableIn: [
      "CA", "AU"
    ],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Breville_Group"
    ],
  },
  
  {
    name: "Brandt",
    ownerCountry: "OT", // Algeria (Cevital)
    headquarterIn: "FR",
    categories: ["appliances", "major-appliances"],
    availableIn: [
      "FR"
    ],
    sourceLinks: [
      "https://fr.wikipedia.org/wiki/Brandt_(entreprise)",
    ],
  },
  {
    name: "Electrolux",
    ownerCountry: "SE",
    categories: ["appliances", "major-appliances", "small-appliances"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Electrolux",
      "http://www.electrolux.com/",
    ],
  },
  {
    // SMEG is represented worldwide with 16 branches, in Great Britain, France, Belgium, Netherlands, 
    // Germany, Sweden, Denmark, Spain, Portugal, Russia, Ukraine, Kazakhstan, South Africa, USA, Australia
    name: "Smeg",
    ownerCountry: "IT",
    categories: ["appliances", "major-appliances"],
    availableIn: ["UK", "IE", "FR", "BE", "NL", "DE", "SE", "DK", "PT", "UA", "AU"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Smeg_(appliances)",
    ],
  },
  {
    name: "Bosch",
    ownerCountry: "DE",
    categories: ["appliances", "major-appliances", "small-appliances"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Bosch_(company)",
      "https://www.bosch.com/",
    ],
  },
  {
    name: "Klarstein",
    ownerCountry: "DE",
    availableIn: ["DE"],
    categories: ["appliances", "small-appliances"],
    sourceLinks: [
      "https://de.wikipedia.org/wiki/Berlin_Brands_Group",
    ],
  },
  {
    name: "Miele",
    ownerCountry: "DE",
    categories: ["appliances", "major-appliances"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Miele",
      "https://www.miele.com/",
    ],
  },
  {
    name: "Amica",
    ownerCountry: "PL",
    categories: ["appliances", "major-appliances"],
    availableIn: [
      "PL", "DE", "UK"
    ],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Amica_(company)",
    ],
  },
  {
    name: "Unique Applicances",
    ownerCountry: "CA",
    categories: ["appliances", "major-appliances"],
    availableIn: [
      "CA"
    ],
    sourceLinks: [
      "https://uniqueappliances.com/",
    ],
  },
  
];